/**
 * @file 判断cell类型的函数
 * @author FranckChen(chenfan02@baidu.com)
 */

import {IMarkdownCell} from './markdownCell';
import {ICodeCell} from './codeCell';

export const isMarkdownCell = function (cell: any): cell is IMarkdownCell {
    return cell?.cell_type === 'markdown';
};

export const isCodeCell = function (cell: any): cell is ICodeCell {
    return cell?.cell_type === 'code';
};
